import { render, staticRenderFns } from "./video_switch_log.vue?vue&type=template&id=07c7e60b&scoped=true"
import script from "./video_switch_log.vue?vue&type=script&lang=ts"
export * from "./video_switch_log.vue?vue&type=script&lang=ts"
import style0 from "./video_switch_log.vue?vue&type=style&index=0&id=07c7e60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7e60b",
  null
  
)

export default component.exports